import React from "react";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  OutlinedInput,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Tracking({
  SettingRow,
  SettingTextRow,
  formData,
  handleChange,
  saving,
  handleMapLayersChange,
  handleTrackingLanguagesChange,
  languageChangeDurationOptions,
  languages,
  handleRequestChange,
  handleLanguageChange,
  backUpDuration,
  handleToggleChange,
  inactiveVehicleTimeoutOptions,
  distanceThresholdOptions,
  averageStopTimeOptions,
  arrivingStatusDistanceOptions,
  historyPointsMarkerOptions,
  inactiveTimeOptions,
  tripDurationOptions,
  handleVehicleStatusChange,
  vehicleStatusOptions,
  historyPointDistanceOptions,
  onMaxSpeedBlur,
  onVehiclesCountBlur,
}) {
  const { t } = useTranslation();

  return (
    <Box className="settings-container">
      <SettingRow
        label={t(
          "Halt time required to change Vehicle status from active to Idle",
        )}
        name="inactiveTime"
        value={formData.inactiveTime}
        onChange={handleChange}
        options={inactiveTimeOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />
      {/* <SettingRow
            label={t("Vehicle Dead Time")}
            name="deadTime"
            value={formData.deadTime}
            onChange={handleChange}
            options={deadTimeOptions.map((opt) => ({
              code: opt.value,
              name: opt.label,
            }))}
            disabled={saving}
          /> */}
      <SettingTextRow
        label={t("Max Speed (km/h)")}
        name="maxSpeed"
        value={formData.maxSpeed}
        onChange={handleChange}
        onBlur={onMaxSpeedBlur}
        disabled={saving}
        type="number"
        min={0}
      />
      <SettingRow
        label={t(
          "Default Duration to complete the trip on route in the absence of schedule",
        )}
        name="tripDuration"
        value={formData.tripDuration}
        onChange={handleChange}
        options={tripDurationOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />
      {/* Inactive Vehicle Timeout */}
      {/* <SettingRow
            label={t("Vehicle Idle Timeout")}
            name="inactiveVehicleTimeout"
            value={formData.inactiveVehicleTimeout}
            onChange={handleChange}
            options={inactiveVehicleTimeoutOptions.map((opt) => ({
              code: opt.value,
              name: opt.label,
            }))}
            disabled={saving}
          /> */}
      <SettingRow
        label={t("Distance to show next stop after vehicle leaves a stop")}
        name="nextStopDistance"
        value={formData.nextStopDistance}
        onChange={handleChange}
        options={distanceThresholdOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />
      {/* <Box className="setting-row">
            <Typography className="form-label">
              {t("Vehicle Color - U-Turn")}
            </Typography>
            <Box sx={{ flex: 1 }}>
              <MultiColorPicker
                value={formData.vehicleColorUTurn}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "vehicleColorUTurn",
                      value: e.target.value,
                    },
                  })
                }
                disabled={saving}
              />
            </Box>
          </Box> */}
      {/* <Box className="setting-row">
            <Typography className="form-label">
              {t("Intermediate Point Icon")}
            </Typography>
            <Box sx={{ flex: 1 }}>
              <FormControl fullWidth disabled={saving}>
                <Select
                  name="intermediatePointIconType"
                  value={formData.intermediatePointIconType}
                  onChange={handleChange}
                  sx={{
                    height: "76px",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  {intermediatePointIconOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {option.icon ? (
                          <img
                            src={option.icon}
                            alt={option.label}
                            style={{ width: 32, height: 32 }}
                          />
                        ) : null}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box className="setting-row">
            <Typography className="form-label">{t("Origin Icon")}</Typography>
            <Box sx={{ flex: 1 }}>
              <FormControl fullWidth disabled={saving}>
                <Select
                  name="originIconType"
                  value={formData.originIconType}
                  onChange={handleChange}
                  sx={{
                    height: "76px",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  {originIconOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {option.icon ? (
                          <img
                            src={option.icon}
                            alt={option.label}
                            style={{ width: 32, height: 32 }}
                          />
                        ) : null}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box className="setting-row">
            <Typography className="form-label">
              {t("Destination Icon")}
            </Typography>
            <Box sx={{ flex: 1 }}>
              <FormControl fullWidth disabled={saving}>
                <Select
                  name="destinationIconType"
                  value={formData.destinationIconType}
                  onChange={handleChange}
                  sx={{
                    height: "76px",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  {destinationIconOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {option.icon ? (
                          <img
                            src={option.icon}
                            alt={option.label}
                            style={{ width: 32, height: 32 }}
                          />
                        ) : null}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box> */}
      {/* Average Stop Time Configuration */}
      {/* <SettingRow
            label={t("Average Stop Time")}
            name="averageStopTime"
            value={formData.averageStopTime}
            onChange={handleChange}
            options={averageStopTimeOptions.map((opt) => ({
              code: opt.value,
              name: opt.label,
            }))}
            disabled={saving}
          /> */}
      {/* Arriving Status Distance */}
      <SettingRow
        label={t("Vehicle Arriving Status at a Stop ")}
        name="vehicleArrivingDistance"
        value={formData.vehicleArrivingDistance}
        onChange={handleChange}
        options={arrivingStatusDistanceOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />
      {/* Arrived Status Distance */}
      <SettingRow
        label={t("Vehicle Arrived Status at Stop")}
        name="vehicleArrivedDistance"
        value={formData.vehicleArrivedDistance}
        onChange={handleChange}
        options={arrivingStatusDistanceOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />
      <SettingRow
        label={t("Vehicle Deviation Distance")}
        name="vehicleDeviationDistance"
        value={formData.vehicleDeviationDistance}
        onChange={handleChange}
        options={distanceThresholdOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />
      <SettingRow
        label={t("History Points Marker (Time)")}
        name="historyPointInterval"
        value={formData.historyPointInterval}
        onChange={handleChange}
        options={historyPointsMarkerOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />{" "}
      {/* <SettingRow
        label={t("Distance between History Points")}
        name="historyPointDistanceInterval"
        value={formData.historyPointDistanceInterval}
        onChange={handleChange}
        options={historyPointDistanceOptions.map((opt) => ({
          code: opt.value,
          name: opt.label,
        }))}
        disabled={saving}
      />{" "} */}
      <SettingTextRow
        label={t("No. of Vehicles on info panel of stop view")}
        name="vehiclesCount"
        value={formData.vehiclesCount}
        onChange={handleChange}
        onBlur={onVehiclesCountBlur}
        disabled={saving}
        type="number"
        min={0}
      />
      {/* Vehicle Status Selection */}
      <Box className="setting-row">
        <Typography className="form-label">
          {t("Vehicles on info panel of stop view")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <FormControl fullWidth disabled={saving}>
            <Select
              multiple
              name="vehiclesStatus"
              value={formData.vehiclesStatus}
              onChange={handleVehicleStatusChange}
              input={<OutlinedInput />}
              renderValue={(selected) => (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                    maxHeight: "70px",
                    overflowY: "auto",
                  }}
                >
                  {selected.map((value) => (
                    <Box
                      key={value}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        textTransform: "capitalize",
                        backgroundColor: "#8db3d8ad",
                        padding: "4px 8px",
                        borderRadius: "16px",
                      }}
                    >
                      {value}
                    </Box>
                  ))}
                </Box>
              )}
              sx={{
                height: "76px",
                borderRadius: "8px",
                "& .MuiOutlinedInput-root": {
                  minHeight: "48px",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 130,
                    overflow: "auto",
                    "& .MuiMenuItem-root": {
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      padding: "0 16px",
                    },
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#f1f1f1",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#c1c1c1",
                      borderRadius: "4px",
                      "&:hover": {
                        backgroundColor: "#a8a8a8",
                      },
                    },
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
            >
              {vehicleStatusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox
                    checked={formData.vehiclesStatus.indexOf(option.value) > -1}
                  />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      {/* Only Towards Direction Toggle */}
      <Box className="setting-row">
        <Typography className="form-label">
          {t("Seggregate vehicles in different panels by their direction")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.onlyTowardsDestination}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "onlyTowardsDestination",
                      value: e.target.checked,
                    },
                  })
                }
                disabled={saving}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#20A8E0",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#20A8E0",
                  },
                }}
              />
            }
            label=""
          />
        </Box>
      </Box>
      <Box className="setting-row">
        <Typography className="form-label">
          {t("Add idle time to estimated arrival time")}
        </Typography>
        <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.includeIdleTimeInETA}
                onChange={handleToggleChange("includeIdleTimeInETA")}
                disabled={saving}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#20A8E0",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#20A8E0",
                  },
                }}
              />
            }
            label={
              formData.stationaryDelayEnabled ? t("Enabled") : t("Disabled")
            }
            sx={{
              margin: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
                color: formData.stationaryDelayEnabled ? "#414958" : "#757575",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
